import React from 'react'
import { toast } from 'react-toastify'
import { css } from 'glamor'

import {
  fetchPortal,
  updatePortal,
} from '../../../modules/portal-remote/portalService'
import MobileForm from './MobileForm'

export const bottom50px = css({
  bottom: '50px',
})

class MobileFormContainer extends React.Component {
  state = {
    portal: null,
    listings: null,
  }

  async componentDidMount() {
    try {
      let portal = await fetchPortal(this.props.portalID)
      this.setState({ portal })
    } catch (error) {
      toast.error('Fetch Portal, Listings Error: ' + error.message, {
        position: toast.POSITION.BOTTOM_LEFT,
        className: bottom50px,
      })
    }
  }

  handleSubmit = async _portal => {
    try {
      const portal = await updatePortal(_portal)
      this.setState({ portal })
      toast.success('Save Portal:' + portal.title.th + ' Success', {
        position: toast.POSITION.BOTTOM_LEFT,
        className: bottom50px,
      })
    } catch (error) {
      toast.error('UpdatePortal error' + error.message, {
        position: toast.POSITION.BOTTOM_LEFT,
        className: bottom50px,
      })
    }
  }

  render() {
    if (this.state.portal)
      return <MobileForm {...this.state} onSubmit={this.handleSubmit} />
    return null
  }
}
export default MobileFormContainer



// WEBPACK FOOTER //
// ./src/components/templates/mobileForm/MobileFormContainer.js